import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  dashboardData: null,
  dashboardError: '',
  dashboardLoading: false,
  TopCoursesData: null,
  TopCoursesDataError: '',
  TopCoursesLoading: false,
  TeacherReportLoading: false,
  TeacherReportData: '',
  TeacherReportError: null,
}

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashboardLoading: (state) => {
      state.dashboardLoading = true;
      state.dashboardData = null;
      state.dashboardDataError = '';
    },
    setDashboardData: (state, action) => {
      state.dashboardLoading = false;
      state.dashboardData = action.payload;
      state.dashboardDataError = '';
    },
    setDashboardError: (state, action) => {
      state.dashboardLoading = false
      state.dashboardData = null
      state.dashboardError = action.payload;
    },
    resetDashboardData: (state, action) => {
      state.dashboardLoading = false
      state.dashboardData = null
      state.dashboardError = ''
    },
    setTopCoursesLoading: (state) => {
      state.TopCoursesLoading = true;
      state.TopCoursesData = null;
      state.TopCoursesDataError = '';
    },
    setTopCoursesdData: (state, action) => {
      state.TopCoursesLoading = false;
      state.TopCoursesData = action.payload;
      state.TopCoursesDataError = '';
    },
    setTopCoursesError: (state, action) => {
      state.TopCoursesLoading = false
      state.TopCoursesData = null
      state.TopCoursesError = action.payload;
    },
    setTeacherReportLoading: (state) => {
      state.TeacherReportLoading = true;
      state.TeacherReportData = null;
      state.TeacherReportError = '';
    },
    setTeacherReportData: (state, action) => {
      state.TeacherReportLoading = false;
      state.TeacherReportData = action.payload;
      state.TeacherReportError = '';
    },
    setTeacherReportError: (state, action) => {
      state.TeacherReportLoading = false;
      state.TeacherReportData = null;
      state.TeacherReportError = action.payload;
    }, 
    resetTeacherReportData: (state) => {
      state.TeacherReportLoading = false;
      state.TeacherReportData = null;
      state.TeacherReportError = '';
    }

  },
})

// Action creators are generated for each case reducer function
export const { setDashboardData, resetDashboardData, setDashboardLoading, 
  setDashboardError,setTopCoursesLoading,setTopCoursesdData,
  setTopCoursesError, setTeacherReportLoading,  setTeacherReportData, setTeacherReportError,
  resetTeacherReportData} = dashboardSlice.actions

export default dashboardSlice.reducer;